import { filter, equals, pathOr, head, map, find } from 'ramda';
import {
  ACCOUNT,
  DEEDSY_SH_BORROWER,
  DEEDSY_SH_COBORROWER,
  KIND_LOANAPP,
  KIND_LOANAPP_ROLE,
  OBJECT_META,
  OWNER_REFERENCES,
} from 'src/services/constants';
import { isNotEmpty } from 'src/utilities/hasValue';

export const findOwnerReferenceOfKind = (data: any, kind: string) => {
  const isKind = (q: any) => equals(kind, pathOr('', ['kind'], q));
  const _data = find(
    isKind,
    pathOr([], [OBJECT_META, OWNER_REFERENCES], data)
  )
  return pathOr('', ['uid'], _data);
};
export const getLoanRoleId = (resource: any) => {
  return findOwnerReferenceOfKind(resource, KIND_LOANAPP_ROLE) || ''
}

export const getLoanAppId = (resource: any) => {
  return findOwnerReferenceOfKind(resource, KIND_LOANAPP) || ''
}

export const getAccountId = (resource: any) => {
  return pathOr('', [OBJECT_META, ACCOUNT], resource)
}

export const filterOwnerRefernceOfUidInResource = (data: any, uid: string) => {
  const isUid = (q: any) => equals(uid, pathOr('', ['uid'], q));
  return map((x: any) => {
    return pathOr('', ['uid'], x);
  },
    filter(
      isUid,
      pathOr([], [OBJECT_META, OWNER_REFERENCES], data)
    ));
}

export const findOwnerReferenceOfUid = (data: any, uid: string) => {
  return head(filterOwnerRefernceOfUidInResource(data, uid));
};

export const filterResourcesByOwnerReferenceId = (resources: any, roleId: string) => {
  return filter((r: any) => isNotEmpty(findOwnerReferenceOfUid(r, roleId)), resources || [])
}

/*
this method is used to filter the object has object_meta->account match with given
accountId
*/
export const filterResourcesByAccountId = (resources: any, accountId: string) => {
  return filter((r: any) => equals(getAccountId(r), accountId), resources || [])
}

export const findResourcesByOwnerReferenceId = (resources: any, roleId: string) => {
  return head(filterResourcesByOwnerReferenceId(resources, roleId))
}

export const findCategoryInLabels = (data: any) => {
  const fn = (n: any) => {
    if (equals(n, DEEDSY_SH_BORROWER) || equals(n, DEEDSY_SH_COBORROWER)) {
      return n;
    }
  };
  return filter(fn, data || []);
};
